'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M16 112l0 352 480 0 0-352-480 0zm48 48l320 0 0 256-320 0 0-256zm400 52a28 28 0 1 1 -56 0 28 28 0 1 1 56 0zm0 80a28 28 0 1 1 -56 0 28 28 0 1 1 56 0z', 'M152-3.3l5.7 5.7 93.7 93.7 9.4 0 93.7-93.7 5.7-5.7 11.3 11.3-5.7 5.7-82.3 82.3 228.7 0 0 384-512 0 0-384 228.7 0-82.3-82.3-5.7-5.7 11.3-11.3zM264 112l-248 0 0 352 480 0 0-352-232 0zM436 224a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm0-40a28 28 0 1 1 0 56 28 28 0 1 1 0-56zm0 120a12 12 0 1 0 0-24 12 12 0 1 0 0 24zm0-40a28 28 0 1 1 0 56 28 28 0 1 1 0-56zM80 176l0 224 288 0 0-224-288 0zM64 160l320 0 0 256-320 0 0-256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;